import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/AppointmentStore';
import { ToastContainer } from "react-toastify";
import Container from '../../components/Container';


class Appointment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ref: "",
            showing: false,
            startDate: new Date(),
            showApply: true,
            tempAppoinmentObj: [],
            containers: [],
            avaibleDateObj: {
                CurrentDate: new Date(),
            },
            capacityShowApply: true
        };


        this.availableDates = [new Date()];
        this.save = this.save.bind(this);
    }
    componentDidMount() {
        if (this.props.location.search !== "") {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const orderId = params.get('orderId');
            this.setState({ orderId: orderId })
            this.props.getContainers(orderId);
            var ell = this.props;
            this.props.getAvaibleDates(this.state.avaibleDateObj);

        }
    }

    componentDidUpdate() {
        if (this.props.data.containers.length > 0 && this.state.containers[0] != this.props.data.containers[0]) {
            this.setState({
                containers: this.props.data.containers,
            });
        }
    }

    _handleChange(obj) {
        console.log("obj", obj);
        let _tempAppoinmentObj = [...this.state.tempAppoinmentObj];
        let _obj = _tempAppoinmentObj.find(o => o.containerID === obj.containerID);
        if (_obj !== undefined) {
            let index = _tempAppoinmentObj.indexOf(_obj);
            _tempAppoinmentObj.fill(_tempAppoinmentObj[index] = obj, index, index++);
        }
        else {
            _tempAppoinmentObj.push(obj);
        }
        this.setState({ tempAppoinmentObj: _tempAppoinmentObj }, () => { console.log('tempAppoinmentObj', this.state.tempAppoinmentObj) });

        let _handledAppointmentDate = this.props.dataAva_dates.findIndex(x => new Date(x.day).toDateString() == new Date(obj.AppointmentDate).toDateString());
        if (_handledAppointmentDate > -1) {
            this.props.dataAva_dates[_handledAppointmentDate].capacity = this.props.dataAva_dates[_handledAppointmentDate].capacity - 1;
            if (this.state.containers.length > this.props.dataAva_dates[_handledAppointmentDate].capacity && this.state.showApply) {
                console.log("thisstate:", this.state.showApply);
            }
        }

        if (_obj !== undefined) {
            let _oldHandledAppointmentDate = this.props.dataAva_dates.findIndex(x => new Date(x.day).toDateString() == new Date(_obj.AppointmentDate).toDateString());
            if (_oldHandledAppointmentDate > -1) {
                this.props.dataAva_dates[_oldHandledAppointmentDate].capacity = this.props.dataAva_dates[_oldHandledAppointmentDate].capacity + 1;
            }
        }


    }

    _handleApply(containerID) {
        let _tempAppoinmentObj = [...this.props.data.containers];
        console.log("props", this.props.data.containers);

        let _tempStateAppoinmentObj = [...this.state.tempAppoinmentObj];
        let _obj = _tempAppoinmentObj.find(o => o.deliveryContainerId === containerID);
        if (_obj !== undefined) {
            let index = _tempAppoinmentObj.indexOf(_obj);
            console.log("index", index)
            this.props.data.containers.map((item, key) => {
                _tempAppoinmentObj[key].prePull = _tempStateAppoinmentObj[index].prePull;
                _tempAppoinmentObj[key].dropOff = _tempStateAppoinmentObj[index].dropOff;
                _tempAppoinmentObj[key].isAM = _tempStateAppoinmentObj[index].isAM;
                _tempAppoinmentObj[key].isPM = _tempStateAppoinmentObj[index].isPM;
                _tempAppoinmentObj[key].isStrict = _tempStateAppoinmentObj[index].isStrict;
                _tempAppoinmentObj[key].StrictTime = _tempStateAppoinmentObj[index].StrictTime;
                _tempAppoinmentObj[key].AppointmentDate = _tempStateAppoinmentObj[index].AppointmentDate;
                return true;
            });
        }
        console.log("app Obj", _tempAppoinmentObj)
    }



    save() {
        let _changedAppointments = [...this.state.tempAppoinmentObj];
        console.log("containers", _changedAppointments);
        this.props.saveAppointment([..._changedAppointments])
    }

    render() {
        return (
            <main>
                <ToastContainer autoClose={3000} />
                <div className="row" style={{ marginTop: 120, paddingLeft: 40 }}><h2>Appointment {console.log("containerdate:", this.props.dataAva_dates)} </h2></div>
                <div className="row p-3">
                    {this.state.containers.map((container, key) =>
                        <Container
                            key={key}
                            keyVal={key}
                            containerID={container.deliveryContainerId.toString()}
                            appointmentDate={container.appointmentDate}
                            availableDatee={container.availableDate}
                            containerNo={container.containerNumber}
                            erd={container.lastFreeDayDate}
                            cutOffDate={container.returnLastFreeDayDate}
                            handleChange={(obj) => this._handleChange(obj)}
                            orderId={container.deliveryOrderId}
                            handleApply={(containerID) => this._handleApply(containerID)}
                            includeDates={(availableDatee, cutOffDate) => this._calculateAvailableDate(availableDatee, cutOffDate)}
                            totalCapacity={this.props.dataAva_dates}
                            totalContainerCount={this.state.containers.length}
                            capacityShowApply={this.state.capacityShowApply}
                            prePullCheck={container.isPrepull}
                            dropOffCheck={container.isDropOff}
                            isPMCheck=  { container.isPM }
                            isAMCheck = { container.isAM }
                            isStrictCheck={container.IsAppointmentStrictTime}
                            startDate={container.appointmentDate}

                            appointmentTime = { container.appointmentTime }


                        />
                    )}
                </div>
                <div className="row justify-content-start" style={{ marginLeft: 30 }}>
                    <button className="btn btn-success" onClick={() => this.save()}>Save</button>
                </div>
            </main>
        )
    }
}

export default connect(
    state => state.appointmentData,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Appointment);



// WEBPACK FOOTER //
// ./src/view/Appointment/Appointment.js